import { render, staticRenderFns } from "./pembuatan_dbkb_standard.vue?vue&type=template&id=1eb13209&"
import script from "./pembuatan_dbkb_standard.vue?vue&type=script&lang=js&"
export * from "./pembuatan_dbkb_standard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports